import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Section from 'helpers/Section';
import {cleanHtml} from 'helpers/commonHelper';

const SectionWrapper = ({title, subtitle, description, bgColor, children}) => {
  const sectionClass = classNames('pt-4 mb-6', bgColor);

  return (
    <Section sectionClass={sectionClass}>
      <div className="text-center">
        <div className="text-accent text-small">{title}</div>
        <div className="mt-1 mb-3 font-bold display-4">{subtitle}</div>
        <div className="mini-rectangle-line mb-4 bg-primary mx-auto" />
        {description && <div className="mb-5" dangerouslySetInnerHTML={{__html: cleanHtml(description)}} />}
      </div>
      {children}
    </Section>
  );
};

SectionWrapper.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  description: PropTypes.string,
  bgColor: PropTypes.string,
  children: PropTypes.node.isRequired
};

export default SectionWrapper;
